import { Textarea } from '@mantine/core'
import classes from './styles.module.css'

export default Textarea.extend({
    classNames: { input: classes.input },
})
